<script>
import PrimaryFooter from "../components/layouts/PrimaryFooter.vue";
import PrimaryHeader from "../components/layouts/PrimaryHeader.vue";
import PrimaryLogo from "../components/logos/PrimaryLogo.vue";
import ScrollReveal from "scrollreveal";
import CarouselTemplate from "../components/carousel/carouselTemplate.vue";
import videoTemplate from "../components/video-content/videoTemplate.vue";
import Overlay from "../components/overlay/overlay.vue";
import CarouselSimple from "../components/carousel/carouselSimple.vue";
import Whatsapp from '../components/whatsappIcon/Whatsapp.vue';

export default {
  name: "apresentacao",
  components: {
    PrimaryLogo,
    PrimaryHeader,
    PrimaryFooter,
    CarouselTemplate,
    videoTemplate,
    Overlay,
    CarouselSimple,
    Whatsapp,
  },
  data() {
    return {
      toggleVideo: false,
      streamerInfo: {},
      video: {
        src: "",
      },
      streamers: [
        {
          name: "SUPER XANDÃO",
          linkName: "twitch.tv/xandaoogod",
          link: "https://www.twitch.tv/xandaoogod",
          gifSrc: require("@/assets/streamers/gifs/xandao.gif"),
          iconSrc: require("@/assets/streamers/icons/superxandao-icon.png"),
          videoSrc: require("@/assets/video/xandao.mp4"),
        },
        {
          name: "Wanessawolf",
          linkName: "twitch.tv/wanessawolf",
          link: "https://www.twitch.tv/wanessawolf",
          gifSrc: require("@/assets/streamers/gifs/wanessa.gif"),
          iconSrc: require("@/assets/streamers/icons/wannessa-wolf-icon.jpg"),
          videoSrc: require("@/assets/video/wanessa.mp4"),
        },
        {
          name: "Dona",
          linkName: "twitch.tv/dona",
          link: "https://www.twitch.tv/dona",
          gifSrc: require("@/assets/streamers/gifs/dona.gif"),
          iconSrc: require("@/assets/streamers/icons/dona-icon.png"),
          videoSrc: require("@/assets/video/dona.mp4"),
          style: {
            objectPosition: "0px",
          },
        },
        {
          name: "Nerissalove",
          linkName: "twitch.tv/nerissalove",
          link: "https://www.twitch.tv/nerissalove",
          iconSrc: require("@/assets/streamers/icons/nerissalove-icon.png"),
          gifSrc: require("@/assets/streamers/gifs/nerissa.gif"),
          videoSrc: require("@/assets/video/nerissa.mp4"),
          style: {
            objectPosition: "-280px 0px",
          },
        },
        {
          name: "Muriloso",
          linkName: "twitch.tv/murilosoo",
          link: "https://www.twitch.tv/murilosoo",
          iconSrc: require("@/assets/streamers/icons/muriloso-icon.png"),
          gifSrc: require("@/assets/streamers/gifs/muriloso.gif"),
          videoSrc: require("@/assets/video/muriloso.mp4"),
          style: {
            objectPosition: "-280px 0px",
          },
        },
        {
          name: "Sabrinoca",
          linkName: "twitch.tv/sabrinoca",
          link: "https://www.twitch.tv/sabrinoca",
          iconSrc: require("@/assets/streamers/icons/sabrinoca-icon.png"),
          gifSrc: require("@/assets/streamers/gifs/sabrinoca.gif"),
          videoSrc: require("@/assets/video/sabrinoca.mp4"),
          style: {
            objectPosition: "-40px 0px",
          },
        },
      ],
      iaVoiceData: [],
      audioId: null,
      isPlaying: false,
    };
  },

  methods: {
    shuffleArray() {
      this.streamers.sort(() => Math.random() - 0.5);
    },

    modelSample(setAudio, id) {
      this.isPlaying = true;
      if (id == this.setAudioId) return;
      this.audioId = id;
      const audio = new Audio(setAudio);

      audio.play();

      audio.addEventListener("ended", () => {
        this.isPlaying = false;
      });
    },
  },

  mounted() {
    const sr = ScrollReveal(); // Crie uma instância do ScrollReveal

    sr.reveal(".animated-element", {
      // Opções de animação
      duration: 1000, // Duração da animação (em milissegundos)
      distance: "30px", // Distância de deslocamento do elemento
      origin: "bottom", // Origem da animação
      easing: "ease-out", // Curva de aceleração da animação
    });

    sr.reveal(".animated-bottom", {
      // Opções de animação
      duration: 1000, // Duração da animação (em milissegundos)
      distance: "100px", // Distância de deslocamento do elemento
      origin: "bottom", // Origem da animação
      easing: "ease-out", // Curva de aceleração da animação
      interval: 600,
    });
    sr.reveal(".animated-top", {
      // Opções de animação
      duration: 1000, // Duração da animação (em milissegundos)
      distance: "100px", // Distância de deslocamento do elemento
      origin: "top", // Origem da animação
      easing: "ease-out", // Curva de aceleração da animação
    });
    sr.reveal(".animated-left", {
      // Opções de animação
      duration: 1000, // Duração da animação (em milissegundos)
      distance: "200px", // Distância de deslocamento do elemento
      origin: "left", // Origem da animação
      easing: "ease-out", // Curva de aceleração da animação
    });
    sr.reveal(".animated-right", {
      // Opções de animação
      duration: 1000, // Duração da animação (em milissegundos)
      distance: "200px", // Distância de deslocamento do elemento
      origin: "right", // Origem da animação
      easing: "ease-out", // Curva de aceleração da animação
      delay: 500,
    });

    sr.reveal(".animated-scaleUp", {
      duration: 1000, // Duração da animação (em milissegundos)
      scale: 0.9,
    });

    this.$axios.get("AIVoices/list-models").then((res) => {
      this.iaVoiceData = res.data.models;
    });
  },
  created() {
    localStorage.removeItem("email");
    this.shuffleArray();
  },
};
</script>

<template >
  <div class="dark-mode">
    <div class="body-content">
      <main class="presentantionPage">
        <PrimaryHeader />
        <section class="animated-element primary-wrapper">
          <div class="content-wrapper">
            <div class="content-left">
              <h1 class="animated-bottom">
                Receba seus donates pela
                <span class="gradient-text inherit"> taxa mais baixa </span>
              </h1>
              <p class="animated-bottom">
                Receba doações em texto, áudio e mensagens personalizadas em IA,
                tudo por uma taxa de 3.9%. Crie sua conta agora e comece a
                receber doação de uma forma única e divertida!
              </p>

              <router-link
                to="/criar-conta"
                class="animated-bottom btn btn-primary"
                >Crie sua conta</router-link
              >

              <div class="animated-bottom info">
                <div>
                  <h5>1M+</h5>
                  Donates
                </div>
                <div>
                  <h5>17K+</h5>
                  Streamers
                </div>
                <div>
                  <h5>R$6M+</h5>
                  Transacionados
                </div>
              </div>
            </div>

            <div class="animated-right" id="carouselStreamers">
              <carousel-template id="carousel" :count="streamers.length">
                <template
                  v-for="(streamer, index) in streamers"
                  :key="index"
                  #[index+1]
                >
                  <div class="contentSlide">
                    <div
                      @click="
                        toggleVideo = true;
                        streamerInfo = {
                          name: streamer.name,
                          linkName: streamer.linkName,
                          link: streamer.link,
                          icone: streamer.iconSrc,
                        };
                        video = {
                          src: streamer.videoSrc,
                        };
                      "
                      class="img-content"
                    >
                      <img
                        :style="streamer.style ? streamer.style : {}"
                        :src="streamer.gifSrc"
                      />
                    </div>

                    <a target="_blank" class="cardStreamer">
                      <div class="backgroundCard"></div>
                      <div class="icon-content">
                        <img :src="streamer.iconSrc" alt="Icone" />
                      </div>
                      <div class="info">
                        <h3>{{ streamer.name }}</h3>
                        <p>{{ streamer.linkName }}</p>
                      </div>
                    </a>
                  </div>
                </template>
              </carousel-template>
            </div>
          </div>
        </section>

        <transition name="fadeGrowingCenterFixed">
          <section v-if="toggleVideo" class="content-video">
            <i class="bx bx-x close-button" @click="toggleVideo = false"></i>
            <videoTemplate :video="video" :streamer="streamerInfo" />
          </section>
        </transition>

        <Overlay :closeModal="toggleVideo" @closeModal="toggleVideo = $event" />

        <section>
          <h4 class="text-center gradient-text">Integrações</h4>

          <div class="intergration-content">
            <div class="integration">
              <img
                src="../assets/integrations-logo/streamlabs.png"
                alt="streamlabs"
              />
            </div>
            <!-- <div class="integration">
            <img
              src="../assets/integrations-logo/streamdeck.svg"
              alt="streamdeck"
            />
          </div> -->
            <div class="integration">
              <img
                src="../assets/integrations-logo/streamelement.png"
                alt="streamelement"
              />
            </div>
            <!-- <div class="integration">
            <img src="../assets/integrations-logo/twitch.svg" alt="twitch" />
          </div>
          <div class="integration">
            <img src="../assets/integrations-logo/discord.svg" alt="discord" />
          </div> -->
          </div>
        </section>

        <section class="section-info">
          <div class="containerInfo">
            <h2 class="gradient-text">Mas por que eu deveria usar o PixGG?</h2>

            <div class="infos-pixgg">
              <div class="cardInfo">
                <img src="../assets/icons/wallet.svg" alt="icons" />
                <h4>Inteligência Artificial</h4>
                <p>
                  Receba mensagens de áudio com a voz de personagens famosos e
                  engraçados, sem cobrança adicional
                </p>
              </div>
              <div class="cardInfo">
                <img src="../assets/icons/combined-shape.svg" alt="icons" />
                <h4>Integração nativa</h4>
                <p>
                  Você pode usar o app de stream que você quiser. OBS?
                  Streamlabs? XSplit? Tanto faz! Nossa integração nativa
                  funciona com todos!
                </p>
              </div>
              <div class="cardInfo">
                <img src="../assets/icons/flag-icon.svg" alt="icons" />
                <h4>Personalização</h4>
                <p>
                  Personalize toda a sua página de donate e deixe a sua cara!
                  Você pode adicionar imagens, mudar as cores e muito mais!
                </p>
              </div>
            </div>
          </div>
        </section>

        <section class="iaInfo">
          <h2 class="gradient-text">Vozes por IA</h2>
          <p>Conheça as vozes que tocarão na sua live</p>

          <carousel-simple id="carouselIAvoice" :count="iaVoiceData.length">
            <template
              v-for="(ia, index) in iaVoiceData"
              :key="index"
              #[index+1]
            >
              <div
                @click="modelSample(ia.modelSample, ia.modelId)"
                class="cardIAVoice"
                :class="{ selected: audioId == ia.modelId }"
              >
                <div class="content-image">
                  <img :src="ia.modelImage" alt="Icone da IA" />
                  <i
                    v-if="audioId == ia.modelId && isPlaying"
                    class="bx bx-volume-full"
                  ></i>
                </div>

                <p>{{ ia.modelName }}</p>
              </div>
            </template>
          </carousel-simple>
        </section>
      </main>
      <span class="linesIlustration"></span>
    </div>
    <PrimaryFooter />

    <whatsapp/>
  </div>
</template>

<style scoped>
@import "../styles/global.css";
@import "../styles/logged-out.css";

main {
  overflow: visible !important;
}

.btn {
  border-radius: 60px;
}

.btn.btn-primary {
  background-color: #2f80ed;
}

#carouselStreamers {
  width: 100%;
  max-width: 616px;
  position: relative;
  user-select: none;
  top: 0px;
  height: calc(100vh - 450px);
}

#carousel {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

#carousel::before {
  content: "";
  position: absolute;
  top: 250px;
  left: 80px;
  background-color: #ad00ff;
  width: 210px;
  height: 200px;
  filter: blur(70px);
  z-index: -2;
  opacity: 21%;
}

#carousel::after {
  content: "";
  position: absolute;
  bottom: -60px;
  right: 0px;
  background-color: #ad00ff;
  width: 200px;
  height: 400px;
  filter: blur(51px);
  z-index: -1;
  opacity: 21%;
}

.contentSlide {
  width: 100%;
  position: relative;
  margin: 130px 0px;
}

.contentSlide::before {
  content: "";
  position: absolute;
  right: 96px;
  border-radius: 20px;
  transform: skewX(-10deg);
  border: 1.6px solid rgba(255, 255, 255, 0.3);
  height: 70%;
  width: 370px;
  top: 0px;
  transition: 0.8s;
  background-image: linear-gradient(
    15deg,
    rgba(255, 255, 255, 0.15) -140%,
    transparent
  );
}

.carousel__slide--active .contentSlide::before {
  top: -35px;
  width: calc(100% - 123px);
  max-width: 410px;
}

.img-content {
  height: 445px;
  border-radius: 15px;
  overflow: hidden;
  transform: skewX(-10deg) scale(0.9);
  transition: 0.8s ease-in-out;
}

.carousel__slide--active .img-content {
  transform: skewX(-10deg) scale(1);
  max-width: 445px;
  margin: 0px 40px 0px auto;
  width: calc(100% - 77px);
  border: 10px solid transparent;
}

.carousel__slide--active .img-content:hover {
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.img-content img {
  box-shadow: 0px 0px 10px -4px white;
  object-fit: cover;
  width: 100%;
  height: 100%;
  margin: 40px 0px;
  border-radius: 5px;
  cursor: pointer;
  transform: skewX(10deg) scale(1.2);
}

.contentSlide .cardStreamer {
  display: inline-flex;
  border-radius: 20px;
  border: 1.6px solid rgba(255, 255, 255, 0.3);
  width: auto;
  text-align: left;
  gap: 1.25rem;
  padding: 15px;
  position: absolute;
  bottom: 40px;
  right: 6px;
  z-index: 2;
  overflow: hidden;
  transform: skewX(-15deg) translateX(250%);
  transition: 0.8s linear;
  opacity: 0.2;
}

/* .contentSlide .cardStreamer:hover {
  animation: growingBorder 2s ease-in-out infinite;
} */

@keyframes growingBorder {
  0% {
    border-width: 1px;
  }
  50% {
    border-width: 10px;
  }
  100% {
    border-width: 1px;
  }
}

.carousel__slide--active .contentSlide .cardStreamer {
  transform: skewX(-10deg) translateX(0%);
  opacity: 1;
}

.contentSlide .cardStreamer::after {
  content: "";
  display: none;
}

.backgroundCard {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    165deg,
    rgba(252, 255, 17, 0%) 60%,
    rgba(255, 255, 255, 18%) 100%
  );
  backdrop-filter: blur(22px);
  z-index: -1;
}

.contentSlide .cardStreamer .icon-content {
  width: 67px;
  height: 67px;
  overflow: hidden;
  border-radius: 10px;
  background-color: black;
}

.contentSlide .cardStreamer .icon-content img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

.contentSlide .cardStreamer h3,
.contentSlide .cardStreamer p {
  text-transform: uppercase;
}

.contentSlide .cardStreamer h3 {
  margin-bottom: 5px;
}

.contentSlide .cardStreamer p {
  opacity: 70%;
  color: #fff;
}

.body-content {
  background: linear-gradient(
    120deg,
    rgba(95, 46, 234, 1) -167%,
    rgba(255, 255, 255, 1) 44%,
    rgba(255, 255, 255, 1) 70%,
    rgba(95, 46, 234, 1) 252%
  );
  position: relative;
  padding-bottom: 50vh;
}
.body-content::after {
  content: "";
  position: absolute;
  bottom: -400px;
  left: 50%;
  transform: translateX(-50%);
  width: 50vw;
  height: 500px;
  background-color: #8f00ff;
  border-radius: 50%;
  filter: blur(111px);
  opacity: 27%;
}

.dark-mode .body-content {
  background: #141943;
}

.btn:before,
.btn::after {
  display: none;
}

main.presentantionPage {
  max-width: 1200px;
  width: calc(100% - 2rem);
  margin: auto;
  display: block;
  overflow: hidden;
}

.wrapper-buttons {
  gap: 1.25rem;
}

.primary-wrapper {
  height: calc(100vh - 2.5rem);
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 100px;
  max-height: 580px;
  gap: 1.5rem;
}

.content-wrapper .content-left {
  max-width: 485px;
  position: relative;
  top: -30px;
}

.primary-wrapper .content-wrapper .content-left h1 {
  font-weight: 900;
  font-size: 3.5rem;
  line-height: 60px;
  color: var(--black);
  position: relative;
}

.primary-wrapper .content-wrapper .content-left h1::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: #0500ff;
  z-index: -1;
  filter: blur(90px);
  opacity: 33%;
  border-radius: 50%;
}

.primary-wrapper .content-wrapper .content-left p {
  font-weight: 500;
  font-size: 1.125rem;
  color: var(--black);
  margin-top: 1.875rem;
}

.primary-wrapper .content-wrapper .content-left .btn.btn-primary {
  margin-top: 2rem;
  display: inline-block;
  width: auto;
}

.content-wrapper .content-left .info {
  display: flex;
  gap: 1.5rem;
  margin-top: 2.5rem;
}

.content-wrapper .content-left .info div {
  color: var(--black);
  font-size: 12px;
  font-weight: 300;
}

.content-wrapper .content-left .info h5 {
  font-size: 22px;
  letter-spacing: 2px;
}

section h4 {
  font-size: 36px;
}

.intergration-content {
  display: flex;
  flex-wrap: wrap;
  margin: 2rem auto 0rem;
  justify-content: center;
  gap: 1rem 4rem;
  max-width: 730px;
}

section.section-info {
  margin-top: 140px;
  position: relative;
}

section.section-info::before {
  content: "";
  position: absolute;
  top: calc(100vw - 113vw);
  left: 50%;
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/wave-ilustration.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0px 0px;
  transform: translateX(-50%);
}

section.section-info::after {
  content: "";
  position: absolute;
  right: -50px;
  bottom: -190px;
  background-color: #ad00ff;
  width: 200px;
  height: 400px;
  opacity: 28%;
  filter: blur(81px);
  transform: rotate(45deg);
}

section .containerInfo {
  border-radius: 40px;
  width: 100%;
  background-image: linear-gradient(
    173deg,
    rgba(255, 255, 255, 0.15) -170%,
    transparent
  );
  padding: 65px 50px;
  overflow: hidden;
  position: relative;
  z-index: 2;
}

section .containerInfo::before {
  content: "";
  position: absolute;
  top: -1px;
  left: 0px;
  width: calc(100% + 3px);
  height: calc(100% - 1px);
  z-index: 1;
  z-index: 1;
  border: 1.6px solid rgba(255, 255, 255, 0.3);
  border-radius: 46px;
  left: -3px;
}

section .containerInfo::before {
  z-index: 1;
  border: 1.6px solid rgba(255, 255, 255, 0.2);
  border-radius: 46px;
}

section h2 {
  font-size: 48px;
}

.containerInfo h2 {
  text-align: center;
}

section .infos-pixgg {
  display: flex;
  gap: 80px;
  margin-top: 70px;
}

section .infos-pixgg .cardInfo {
  text-align: center;
}

section .infos-pixgg .cardInfo img {
  height: 60px;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

section .infos-pixgg .cardInfo h4 {
  margin-top: 1.5rem;
  font-size: 28px;
}

section .infos-pixgg .cardInfo p {
  font-size: 18px;
  color: var(--black);
  margin-top: 1.5rem;
}

.iaInfo {
  margin-top: 140px;
  position: relative;
  z-index: 1;
}

.iaInfo::before {
  content: "";
  position: absolute;
  left: 50%;
  top: -380px;
  background-color: #ad00ff;
  width: 150vw;
  height: 912px;
  opacity: 21%;
  transform: translateX(-50%);
  filter: blur(131px);
  border-radius: 50%;
  z-index: -1;
}

.iaInfo p {
  color: var(--black);
}

.content-video {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0px;
  z-index: 10;
  gap: 3rem;
  max-width: 1200px;
  margin: auto;
  z-index: 52;
}

.close-button {
  color: white;
  font-size: 60px;
  cursor: pointer;
  position: absolute;
  top: -70px;
  right: -15px;
}

.gradient-text {
  background-image: linear-gradient(
    155deg,
    rgba(105, 234, 203, 1) 0%,
    rgba(234, 204, 248, 1) 50%,
    rgba(105, 234, 203, 1) 100%
  );
  -webkit-background-clip: text;
  color: transparent !important;
}

section h4.text-center.gradient-text {
  background-image: linear-gradient(
    94deg,
    rgba(105, 234, 203, 1) 45%,
    rgba(234, 204, 248, 1) 48%,
    rgba(105, 234, 203, 1) 62%
  );
}

#carouselIAvoice {
  width: calc(100% - 4rem);
  margin: auto;
  position: relative;
  height: 155px;
  margin-top: 2rem;
}

#carouselIAvoice .content-image {
  max-width: 125px;
  max-height: 124px;
  overflow: hidden;
  border-radius: 15px;
  position: relative;
}

#carouselIAvoice .content-image::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: var(--slow);
  background: red;
}

#carouselIAvoice .cardIAVoice.selected .content-image {
  border: 3px solid #979797;
}

#carouselIAvoice .content-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  object-position: center center;
}

i.bx.bx-volume-full {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 36px;
}

#carouselIAvoice .cardIAVoice.selected .content-image img {
  filter: blur(2px);
}

#carouselIAvoice p {
  margin-top: 0.5rem;
}

.cardIAVoice {
  cursor: pointer;
}

.linesIlustration {
  height: 1.2px;
  width: 100vw;
  background-color: #fff;
  position: absolute;
  bottom: 60px;
  right: -50px;
  transform: rotate(-10deg);
  opacity: 0.1;
}

.linesIlustration::before,
.linesIlustration::after {
  content: "";
  background-color: #fff;
  height: 1.2px;
  width: 100vw;
  display: block;
}

.linesIlustration::before {
  margin-top: 80px;
}

.linesIlustration::after {
  margin-top: 80px;
}

@media screen and (max-width: 995px) {
  .body-content {
    padding-bottom: 80px;
  }

  .primary-wrapper {
    padding-top: 1.5rem;
  }

  .content-wrapper {
    flex-direction: column;
    margin-top: 60px;
    align-items: center;
    max-height: none;
  }

  .primary-wrapper {
    height: auto;
  }

  .content-video {
    width: 100%;
  }

  .primary-wrapper .content-wrapper .content-left {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .primary-wrapper .content-wrapper .content-left h1 {
    font-size: 2.2rem;
    line-height: normal;
    text-align: center;
  }

  .primary-wrapper .content-wrapper .content-left p {
    text-align: center;
    margin-top: 1rem;
    font-size: 1rem;
  }

  .primary-wrapper .content-wrapper img {
    margin-top: 1.5rem;
  }

  .primary-wrapper .content-wrapper .content-left .btn.btn-primary {
    text-align: center;
    margin-top: 1.1rem;
  }

  #carouselStreamers {
    max-width: 550px;
    height: 500px;
    margin: 0px;
  }

  #carouselStreamers::before,
  #carouselStreamers::after {
    content: "";
    display: none;
  }

  section.section-info {
    margin-top: 80px;
  }

  section .containerInfo {
    padding: 1.5rem 1rem;
  }

  .containerInfo h2 {
    font-size: 38px;
  }

  section .infos-pixgg {
    margin-top: 65px;
    flex-wrap: wrap;
  }

  .iaInfo {
    margin-top: 70px;
  }
}
</style>